import React from "react";
import style from "./FormContact.module.css";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

export const FormContact = () => {
  return (
    <div className={style.container}>
      <div className={style.textCont}>
        <h3 className={style.title}>
          ¿Tienes alguna duda? Dejános asesorarte.
        </h3>
        <p className={style.text}>
          Contáctanos y uno de nuestros asesores se comunicará contigo.
        </p>
      </div>

      <div className={style.form}>
        <div className={style.double}>
          <TextField
            label="Nombre..."
            variant="standard"
            className={style.half}
            autoComplete="off"
          />
          <TextField
            id="standard-basic"
            label="Correo..."
            variant="standard"
            className={style.half}
            autoComplete="off"
          />
        </div>

        <TextField
          id="standard-basic"
          label="Empresa(Opcional)..."
          variant="standard"
          autoComplete="off"
        />
        <TextField
          autoComplete="off"
          id="standard-basic"
          label="Teléfono..."
          variant="standard"
        />

        <TextField
          id="standard-multiline-static"
          label="Mensaje..."
          multiline
          rows={4}
          defaultValue=""
          variant="standard"
          autoComplete="off"
        />
        <div>
          {" "}
          <Button variant="contained" color="primary" className={style.btn}>
            Enviar
          </Button>
        </div>
      </div>
    </div>
  );
};
